export default function AffiliateTrip() {
  return (
    <a 
      href="https://www.tkqlhce.com/click-101530017-11947208"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <div
        style={{
          width: "300px",
          margin: "10px auto",
          transition: "all 0.25s ease",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          borderRadius: "8px",
          overflow: "hidden",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
        }}
      >
        <iframe
          src="https://www.trip.com/partners/ad/DB17600823?Allianceid=8523908&SID=317491945&trip_sub1=thefindingspot"
          width="300"
          height="250"
          style={{
            border: "none",
            display: "block",
          }}
          scrolling="no"
          frameBorder="0"
          id="DB17600823"
          title="Trip.com Affiliate Banner"
        ></iframe>
      </div>

      {/* CJ tracking pixel */}
      <img 
        src="https://www.ftjcfx.com/image-101530017-11947208" 
        width="1" 
        height="1" 
        border="0" 
        alt=""
      />
    </a>
  );
}
